import { render, staticRenderFns } from "./FreightTablesIndexView.vue?vue&type=template&id=28c443af&scoped=true"
import script from "./FreightTablesIndexView.vue?vue&type=script&lang=js"
export * from "./FreightTablesIndexView.vue?vue&type=script&lang=js"
import style0 from "./FreightTablesIndexView.vue?vue&type=style&index=0&id=28c443af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c443af",
  null
  
)

export default component.exports